import { displayDate } from "src/utils/dateHandler.util";
import { Amount } from "src/components/Amount";
import { formatScreamingSnakeCase, languageMap } from "src/utils/util";
import { Lounge } from "../../types/lounge.entity";
import { Badge } from "src/components/Badge/Badge";
import { loungeStatusStyles } from "../../utils/lounge-styles";
import { Link, useLocation } from "react-router-dom";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

type Props = {
  data: Lounge[];
};
export const LoungeTable = ({ data }: Props) => {
  const { search } = useLocation();

  return (
    <div>
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
          <thead className="bg-gray-800 text-white text-center">
            <tr>
              <th className="px-4 py-3">Id</th>
              <th className="px-4 py-3">Language</th>
              <th className="px-4 py-3">Search Amount</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Created At</th>
              <th className="px-4 py-3">View</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 && (
              <tr className="text-center">
                <td colSpan={6} className="px-4 py-3">
                  No User Transactions
                </td>
              </tr>
            )}

            {data.map((tx) => (
              <tr key={tx.id} className="text-center odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                <td className="px-4 py-3 border-t border-gray-200 max-w-xs whitespace-nowrap overflow-hidden text-ellipsis">
                  {tx.id}
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{languageMap[tx.langCode]}</td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Amount amount={tx.budget} currency={tx.currency} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(tx.status)} classes={loungeStatusStyles[tx.status]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{displayDate(tx.createdAt)}</td>
                <td className="px-4 py-3 border-t border-gray-200 text-center">
                  <Link
                    to={appendSearchToPath("/lounge-requests/" + tx.id, search)}
                    className="no-underline bg-blue-700 text-white py-2 px-4 rounded-md"
                  >
                    show
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
